import { ThemeOptions } from '@mui/material'

import palette, { neutral } from './Light/palette'

// Componetss
import lightComponents from './Light/components'

export const lightThemeOptions: ThemeOptions = {
  palette,
  components: {
    ...lightComponents,
    MuiAvatar: {
      styleOverrides: {
        root: {
          backgroundColor: neutral[500],
          color: neutral[800]
        }
      }
    },
    MuiCssBaseline: {
      styleOverrides: {
        '*': {
          boxSizing: 'border-box'
        },
        html: {
          MozOsxFontSmoothing: 'grayscale',
          WebkitFontSmoothing: 'antialiased',
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100%',
          width: '100%'
        },
        body: {
          display: 'flex',
          flex: '1 1 auto',
          flexDirection: 'column',
          minHeight: '100%',
          width: '100%'
        },
        '&::-webkit-scrollbar': {
          WebkitAppearance: 'none',
          filter: 'opacity(0.5) !important'
        },
        '&::-webkit-scrollbar:vertical': {
          width: 24
        },
        '&::-webkit-scrollbar:horizontal': {
          height: 24
        },
        '&::-webkit-scrollbar-thumb:vertical': {
          minHeight: 40,
          height: 40,
          borderRadius: 12,
          backgroundColor: neutral[400],
          backgroundClip: 'content-box',
          border: '8px solid transparent'
        },
        '&::-webkit-scrollbar-track-piece:vertical': {
          backgroundClip: 'content-box',
          backgroundRepeat: 'repeat-y',
          border: '3px solid transparent',
          margin: '0px 0px 5px 0px'
        },
        '&::-webkit-scrollbar-thumb:horizontal': {
          width: 40,
          minWidth: 40,
          borderRadius: 12,
          backgroundColor: neutral[400],
          backgroundClip: 'content-box',
          border: '8px solid transparent'
        },
        '&::-webkit-scrollbar-track-piece:horizontal': {
          margin: '0px -5px 0px 0px',
          border: '8px solid transparent',
          backgroundRepeat: 'repeat-x',
          backgroundClip: 'content-box'
        },
        '&::-webkit-scrollbar-track:vertical': {
          marginBottom: '0px'
        },
        '&::-webkit-scrollbar-button:start:decrement': {
          display: 'block'
        },
        '&::-webkit-scrollbar-button:end:increment': {
          display: 'block'
        },
        '&::-webkit-scrollbar-button:vertical:decrement': {
          background: 'url(/icons/arrowUp.png) no-repeat',
          filter: 'contrast(50%)'
        },
        '&::-webkit-scrollbar-button:vertical:increment': {
          background: 'url(icons/arrowDown.png) no-repeat'
        },
        '&::-webkit-scrollbar-button:horizontal:decrement': {
          background: 'url(icons/arrowLeft.png) no-repeat',
          backgroundClip: 'content-box',
          WebkitBackgroundClip: 'content-box',
          height: '16px'
        },
        '&::-webkit-scrollbar-button:horizontal:increment': {
          background: 'url(icons/arrowRight.png) no-repeat',
          backgroundClip: 'content-box',
          height: '16px'
        },
        '&::-webkit-scrollbar-corner': {
          backgroundColor: 'transparent'
        }
      }
    }
  },
  shadows: [
    'none',
    '0px 1px 1px rgba(100, 116, 139, 0.06), 0px 1px 2px rgba(100, 116, 139, 0.1)',
    '0px 1px 2px rgba(100, 116, 139, 0.12)',
    '0px 1px 4px rgba(100, 116, 139, 0.12)',
    '0px 1px 5px rgba(100, 116, 139, 0.12)',
    '0px 1px 6px rgba(100, 116, 139, 0.12)',
    '0px 2px 6px rgba(100, 116, 139, 0.12)',
    '0px 3px 6px rgba(100, 116, 139, 0.12)',
    '0px 2px 4px rgba(31, 41, 55, 0.06), 0px 4px 6px rgba(100, 116, 139, 0.12)',
    '0px 5px 12px rgba(100, 116, 139, 0.12)',
    '0px 6px 12px rgba(0, 0, 0, 0.24);',
    '0px 5px 15px rgba(100, 116, 139, 0.12)',
    '0px 6px 15px rgba(100, 116, 139, 0.12)',
    '0px 7px 15px rgba(100, 116, 139, 0.12)',
    '0px 8px 15px rgba(100, 116, 139, 0.12)',
    '0px 9px 15px rgba(100, 116, 139, 0.12)',
    '0px 10px 15px rgba(100, 116, 139, 0.12)',
    '0px 12px 22px -8px rgba(100, 116, 139, 0.25)',
    '0px 13px 22px -8px rgba(100, 116, 139, 0.25)',
    '0px 14px 24px -8px rgba(100, 116, 139, 0.25)',
    '0px 10px 10px rgba(31, 41, 55, 0.04), 0px 20px 25px rgba(31, 41, 55, 0.1)',
    '0px 25px 50px rgba(100, 116, 139, 0.25)',
    '0px 25px 50px rgba(100, 116, 139, 0.25)',
    '0px 25px 50px rgba(100, 116, 139, 0.25)',
    '0px 25px 50px rgba(100, 116, 139, 0.25)'
  ]
}
